import type {ReactElement} from 'react';
import {useContext} from 'react';
import {emailMakerContext} from '@EmailMakerReact/email-maker-react.context';
import {MOBILE_CSS_PROP_PREFIX, TABLET_CSS_PROP_PREFIX} from '@EmailMakerReact/email-maker-react.constants';
import {EmailMakerCanvasDevice} from '@EmailMakerReact/email-maker-react.types';
import type {ResponsiveSliderControlProps} from '../../slider-control.types';
import {SliderContainer} from '../slider-container/slider-container';
import {ResponsiveVariantSlider} from '../responsive-variant-slider/responsive-variant-slider';
import styles from '../../slider-control.module.scss';

export function ResponsiveSliderControl({component, descriptor, effectiveMax}: ResponsiveSliderControlProps): ReactElement {
  const {state, editor} = useContext(emailMakerContext);
  const currentDevice = state.canvasDevice;

  const mobileProperty = `${MOBILE_CSS_PROP_PREFIX}${descriptor.property}`;
  const tabletProperty = `${TABLET_CSS_PROP_PREFIX}${descriptor.property}`;

  function renderTablet(): ReactElement | null {
    if (!descriptor.isResponsive) {
      return null;
    }
    return (
      <ResponsiveVariantSlider
        activeProperty={tabletProperty}
        component={component}
        descriptor={descriptor}
        editor={editor}
        effectiveMax={effectiveMax}
        isHidden={currentDevice !== EmailMakerCanvasDevice.TABLET}
        responsiveTag={window.i18next.t('pmwjs_tablet')}
      />
    );
  }

  function renderMobile(): ReactElement | null {
    if (!descriptor.isResponsive) {
      return null;
    }
    return (
      <ResponsiveVariantSlider
        activeProperty={mobileProperty}
        component={component}
        descriptor={descriptor}
        editor={editor}
        effectiveMax={effectiveMax}
        isHidden={currentDevice !== EmailMakerCanvasDevice.MOBILE}
        responsiveTag={window.i18next.t('pmwjs_mobile')}
      />
    );
  }

  return (
    <div className={styles.responsiveContainers}>
      <SliderContainer
        activeProperty={descriptor.property}
        component={component}
        descriptor={descriptor}
        effectiveMax={effectiveMax}
        isHidden={currentDevice !== EmailMakerCanvasDevice.DESKTOP}
      />
      {renderTablet()}
      {renderMobile()}
    </div>
  );
}
